import React from "react";

import ReusableTest from "../ReusableTest";

function Test() {
  return <ReusableTest path="listening_test/smc" category="smc"></ReusableTest>;
}

export default Test;
